import * as Yup from 'yup'

export const PurchaseTxSchemas = Yup.object().shape({
  transactionValue: Yup.number(),
  creditValue: Yup.number(),
  loyaltyValue: Yup.number(),
  externalTransactionId: Yup.number().optional().nullable(),
  ident: Yup.string(),
  storeId: Yup.number(),
  deviceCode: Yup.string(),
  cashier: Yup.string(),
  guid: Yup.string(),
  transactionDate: Yup.string(),
  transactionDetail: Yup.array()
    .of(
      Yup.object().shape({
        productCode: Yup.string()
          .nullable()
          .test(
            'product-details-check',
            'If SKU is provided, both Quantity and Unit Price are required.',
            function (value) {
              const { quantity, unitPrice } = this.parent
              if (value && value.trim() !== '') {
                return !!quantity && !!unitPrice
              }
              return true
            }
          ),
        quantity: Yup.string().nullable(),
        unitPrice: Yup.string().nullable(),
      })
    )
    .nullable(),
  comments: Yup.string().optional(),
  traceNumber: Yup.number().optional(),
  reasonId: Yup.number().optional(),
})

export const PurchaseRedemptionTxSchemas = Yup.object().shape({
  transactionValue: Yup.number()
    .test('non-zero', 'Transaction value cannot be 0', value => value !== 0),
  creditValue: Yup.number(),
  loyaltyValue: Yup.number()
    .test('non-zero', 'Loyalty value cannot be 0', value => value !== 0),
  externalTransactionId: Yup.number().optional().nullable(),
  ident: Yup.string(),
  storeId: Yup.number(),
  deviceCode: Yup.string(),
  cashier: Yup.string(),
  guid: Yup.string(),
  transactionDate: Yup.string(),
  transactionDetail: Yup.array()
    .of(
      Yup.object().shape({
        productCode: Yup.string()
          .nullable()
          .test(
            'product-details-check',
            'If SKU is provided, both Quantity and Unit Price are required.',
            function (value) {
              const { quantity, unitPrice } = this.parent
              if (value && value.trim() !== '') {
                return !!quantity && !!unitPrice
              }
              return true
            }
          ),
        quantity: Yup.string().nullable(),
        unitPrice: Yup.string().nullable(),
      })
    )
    .nullable(),
  comments: Yup.string().optional(),
  traceNumber: Yup.number().optional(),
  reasonId: Yup.number().optional(),
})
